import { gql } from 'apollo-angular';

const GET_RFP_BY_ORG_ID = gql`
  query getRfpsByOrg($organizationId: Long) {
    rfpsByOrg(organizationId: $organizationId) {
      id
      status
      type
      offersDueDate
      offersReceivedDate
      pricingExpirationDate
      contractDurations
      contractEffectiveDates
      preferredContractDuration
      preferredContractEffectiveDate
      submissionDate
      hasFormularyPrice
      buyer {
        id
        name
        organizationType
      }
      category {
        id
        name
        type
      }
      spendDateRange {
        startDate
        endDate
      }
      customSpendDateRange {
        bounds
        selected
        hasCustomSpendDateRange
      }
      spend {
        actualSpend
        continuedSpend
        annualizedSpend
      }
      potentialSavings {
        savingsVolume
      }
      recipients {
        spend {
          actualSpend
          potentialSpend
          annualizedPotentialSpend
          marketShare
          annualizedMarketShare
          annualizedSpend
          continuedSpend
        }
      }
    }
  }
`;

export default GET_RFP_BY_ORG_ID;
